import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 9,
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper2,
    boxShadow: theme.shadows[3],
    width: 1200,
    minWidth: 1200,
    marginLeft: 15,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  visible: {
    display: 'flex',
  },
  hidden: { display: 'none' },
  header: {
    width: '100%',
    zIndex: 9,
    padding: 15,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexGrow: 0,
  },
  headerIcon: { color: theme.palette.primary.main },
  content: {
    flexGrow: 1,
    overflow: 'hidden',
    zIndex: 9,

    '& iframe': {
      margin: 0,
      padding: 0,
      width: '100%',
      height: '100%',
      overflow: 'hidden',
    },
  },
  loading: {
    display: 'flex',
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    zIndex: 10,
    opacity: 0.4,
    transition: 'all 500ms ease-in-out',
    backgroundColor: theme.palette.background.paper2,
  },
}))

export default useStyles
